import { RouteConfig } from 'vue-router';

import { TableName } from '@/enums/tableName.enum';
import { beforeCalendarRoute } from '@/routesUtils/calendar';
import { tryParseInt } from '@/utils/number';
import ClubCalendar from '@/views/club/Calendar.vue';

export const clubCalendarRoute: RouteConfig = {
  path: 'calendar/:view',
  name: 'clubCalendar',
  component: ClubCalendar,
  meta: {
    title: 'titles.club.calendar'
  },
  beforeEnter: (to: any, from: any, next: any) => {
    beforeCalendarRoute(to, tryParseInt(to.params.clubId) as number, TableName.Club, next);
  }
};
